/** @format */

export const CURRENT_VERSION = "1.0.12";
